export default __webpack_public_path__ + "static/media/web.1deab727.webm";